export default "__VITE_ASSET__bfc07c64__"